import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';

const PasswordInput = lazy(() => import(/* webpackChunkName: "PasswordInput" */ './components/PasswordInput'));

const wrapInput = (input) => {
    const wrapper = document.createElement('div');
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);

    return wrapper;
};

const passwordInputs = Array.from(document.querySelectorAll('.first-password-input'));
passwordInputs.forEach((element, index) => {
    let firstPasswordNode = null;
    let secondPasswordNode = null;
    let passwordRequirementsNode = null;
    let passwordSubmitButtonNode = null;

    wrapInput(element);
    firstPasswordNode = element;

    const props = {};
    for (const key in element.dataset) {
        props[key] = element.dataset[key];

        try {
            props[key] = JSON.parse(props[key]);
        } catch (e) { } // eslint-disable-line no-empty
    }

    Array.from(document.querySelectorAll('.second-password-input')).forEach((secondPasswordElement, secondPasswordIndex) => {
        if (index === secondPasswordIndex) {
            wrapInput(secondPasswordElement);
            secondPasswordNode = secondPasswordElement;
        }
    });

    Array.from(document.querySelectorAll('.password-requirements')).forEach((passwordRequirementsElement, passwordRequirementsIndex) => {
        if (index === passwordRequirementsIndex) {
            wrapInput(passwordRequirementsElement);
            passwordRequirementsNode = passwordRequirementsElement;
        }
    });

    Array.from(document.querySelectorAll('.password-submit')).forEach((passwordSubmitElement, passwordSubmitIndex) => {
        if (index === passwordSubmitIndex) {
            passwordSubmitButtonNode = passwordSubmitElement;
        }
    });

    render(
        <Suspense fallback={<></>}>
            <PasswordInput
                firstPasswordNode={firstPasswordNode}
                secondPasswordNode={secondPasswordNode}
                passwordRequirementsNode={passwordRequirementsNode}
                passwordSubmitButtonNode={passwordSubmitButtonNode}
                {...props}
            />
        </Suspense>,
        element
    );
});
